import React, { Component } from "react";

// Assets
import CalcLogo from "../../Assets/edit.svg";

// Component
import InsulinIntake from "./InsulinIntake";
import PostGlucose from "./PostGlucose";
import PreGlucose from "./PreGlucose";
import CalcFoodData from "./CalcFoodData";

// Calculation Component
class Calculation extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      activePage: 1,
    };
  }

  renderPage = (pageNo) => {
    this.setState({ activePage: pageNo });
  };

  render() {
    return (
      <div className="Calculation">
        <div className="backBtn">
          <img src={CalcLogo} alt="Setting" />
        </div>
        <div className="Calculation_UserName">
          Good Morning
          <br />
          Aditya Dhamal
        </div>
        <div className="Calculation_Title">
          <div>Get Correct Insulin Dose</div>
          <div></div>
        </div>
        {/*<PreGlucose renderPage={this.renderPage}/> */}

        {this.state.activePage === 2 ? (
          <InsulinIntake renderPage={this.renderPage} />
        ) : this.state.activePage === 3 ? (
          <PostGlucose renderPage={this.renderPage} />
        ) : this.state.activePage === 1 ? (
          <PreGlucose renderPage={this.renderPage} />
        ) : (
          <CalcFoodData renderPage={this.renderPage} />
        )}
      </div>
    );
  }
}

export default Calculation;
